<template>
  <div class="asm-calculator asm-calculator--mobile" v-if="line">
    <div class="asm-calculator__header">
      <div class="asm-calculator__line">
        <line-select/>
      </div>
      <div class="asm-calculator__line-link">
        <a :href="`https://asm.ru/produkciya/${line.slug.toLowerCase()}`"
           class="asm-calculator__link"
           tabindex="-1" target="_blank"
           :title="$t('message.goToDescription')"
        >
          <span class="asm-calculator__link-goto">{{ $t('message.goToDescription') }}</span>
        </a>
      </div>
      <currency-select class="asm-calculator__currency"/>
    </div>
    <div class="asm-calculator__body">
      <ingredient-table-mobile class="asm-calculator__ingredients"/>
      <h4 class="asm-calculator__headline">{{ $t('message.profitabilityBasedOn', [1]) }}</h4>
      <result-table-mobile class="asm-calculator__results"/>

    </div>
    <div class="asm-calculator__panel">
      <div class="asm-calculator__panel-row">
        <div class="asm-calculator__panel-col">
          <default-range-input
            :max="line.capability"
            :min="1"
            :value="capability"
            @input="setCapability"
            class="asm-calculator__panel-range"
            :label="$t('message.capability')"
          >
            <template #measure>{{capability}}&nbsp;{{ $t('measure.m3')}}&nbsp;/&nbsp;{{ $t('message.day')}}</template>
          </default-range-input>
        </div>
        <div class="asm-calculator__panel-col">
          <default-range-input
            :max="30"
            :measure="$tc('plural.dayShort', period)"
            :min="1"
            :value="period"
            @input="setPeriod"
            class="asm-calculator__panel-range"
            :label="$t('message.calculatingPeriod')"
          />
        </div>
      </div>
      <div class="asm-calculator__panel-footer">
        <div class="asm-calculator__profit">
          <div class="asm-calculator__profit-label">{{ $t('message.profit') }}</div>
          <price :currency="result.currency" :num="result.profitInPeriod" class="asm-calculator__profit-value"
                 size="lg"/>
        </div>
        <span class="mt-auto ml-auto">
          <button-reset @click="fetch" class="mr-2"/>
          <button-save-p-d-f @click="savePDF(result)"/>
        </span>
      </div>
    </div>

    <div class="asm-calculator__help">

      <h2 class="h3">{{ $t('message.helpHeader') }}</h2>
      <base-video
        class="my-4"
        thumbnail
        preview="https://i.ytimg.com/vi_webp/HSbOJ_PeeqQ/maxresdefault.webp"
        lightbox
        src="https://youtu.be/HSbOJ_PeeqQ"
        title="Считаем рентабельность оборудования для газобетона в 2020 году"
        duration="3:02"
      />
      <p>{{ $t('message.helpText') }}</p>

      <h2 class="h3">{{ $t('message.helpHeader1') }}</h2>
      <p>{{ $t('message.helpText1') }}</p>
    </div>
    <base-lightbox />
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from "vuex";
  import LineSelect from "./LineSelect";
  import CurrencySelect from "./CurrencySelect";
  import IngredientTableMobile from "./IngredientTableMobile";
  import ResultTableMobile from "./ResultTableMobile";
  import DefaultRangeInput from "../DefaultRangeInput";
  import declOfNum from "../../mixins/declOfNum";
  import Price from "../Price";
  import ButtonReset from "../ButtonReset";
  import ButtonSavePDF from "../ButtonSavePDF";
  import exportPDF from "@/mixins/exportPDF";
  import priceFormatter from "../../mixins/priceFormatter";
  import BaseVideo from "../BaseVideo";
  import BaseLightbox from "../BaseLightbox";

  export default {
    name: "MobileView",
    components: {
      BaseLightbox,
      BaseVideo,
      ButtonSavePDF,
      ButtonReset,
      Price,
      DefaultRangeInput,
      ResultTableMobile,
      LineSelect,
      CurrencySelect,
      IngredientTableMobile
    },
    mixins: [
      declOfNum, exportPDF, priceFormatter
    ],
    computed: {
      /**
       * mapping state variables
       **/
      ...mapState('mobile', [
        'currentUser', "period", "capability"
      ]),
      ...mapGetters('mobile', [
        'result',
        'currency', 'hideChange', 'localIngredients',
        'line', 'recipe', 'localPrice', 'localEnergyTariff', 'localRent', 'localTariff', 'localIngredientPrices', 'localIngredientOptions'
      ]),
    },
    methods: {
      ...mapActions('mobile', [
        'fetch', 'getCountry', 'getCurrency', 'fetch',
        'setPeriod', 'setCapability'
      ]),
    },
    async mounted() {
      await this.getCurrency();
      await this.getCountry();
      await this.fetch();
    },
  }
</script>

<style lang="scss">

  @media screen and (max-width: 23em) {
    html {
      font-size: 0.75em !important;
    }
  }
  .asm-calculator {
    font-size: 1rem;

    &__header {
      display: flex;
      flex-flow: row wrap;
      padding: 2em 1em 0;
      @media screen and (max-width: 23em) {
        padding: 2em 0.75em 0;
      }
    }

    &__help {
      padding: 4em 1em 4em;
      @media screen and (max-width: 23em) {
        padding: 2em 0.75em;
      }
    }

    &__body {
      padding: 0 1em 0;
      @media screen and (max-width: 23em) {
        padding: 0 0.75em 0;
      }
    }

    &__line {
      margin-bottom: 0.5em;
      flex: 0 0 100%;
      max-width: 100%;
      width: 100%;
      padding-right: 0;
      margin-right: 0;

      /*@media screen and (min-width: 40em) {*/
      /*  padding-right: 0.25em;*/
      /*  flex: 0 0 58.33333%;*/
      /*  max-width: 58.33333%;*/
      /*}*/
    }

    &__line-link {
      flex: 0 0 58.33333%;
      max-width: 58.33333%;
      width: 100%;
      padding-left: 0;
      padding-right: 0.25em;

      /*@media screen and (min-width: 40em) {*/
      /*  flex: 0 0 41.66667%;*/
      /*  max-width: 41.66667%;*/
      /*  padding-left: 0.25em;*/
      /*  padding-right: 0;*/
      /*}*/
    }

    &__link {
      display: block;
      border-radius: 3px;
      line-height: 1.714285714285714em;
      padding: 0.5em 0.5em; //7px 8px;
      background-color: #F1F4F9;
      color: #004175;
      text-align: center;
      font-size: 0.875em;
      margin-bottom: 0.5em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: fade;

      &-goto,
      &-line {
        display: inline-block;
      }

      &-line {
        margin-left: 0.5em;
      }
    }

    &__currency {
      margin-bottom: 0.5em;
      padding-left: 0.25em;
      padding-right: 0;
      flex: 0 0 41.66667%;
      max-width: 41.66667%;

      &-select {
        width: 100%;
      }
    }

    &__ingredients {
      margin-bottom: 3em;
    }

    &__results {
      margin-top: 1em;
      margin-bottom: 3em;
    }

    &__headline {
      line-height: 1.5rem;
      font-size: 1.25em;
      font-style: normal;
      font-weight: normal;
    }

    &__panel {
      padding: 0 0.5em 2em;

      @media screen and (max-width: 40em) {
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #145AA0;
        padding: 1.5em 1.75em;
        color: #ffffff;

        & .custom-range::-webkit-slider-thumb {
          background-color: #FFFFFF;
        }
        & .custom-range::-ms-thumb {
          background-color: #FFFFFF;
        }
        & .custom-range::-moz-range-thumb {
          background-color: #FFFFFF;
        }
        /*& .custom-range::-webkit-slider-runnable-track,*/
        /*& .custom-range::-ms-track*/
        & .custom-range::-moz-range-track {
          background-color: #2B78C5;
          height: .375em;
        }
      }

      &-controls {
        display: flex;
        flex-flow: row wrap;
        justify-content: stretch;
        align-content: stretch;

        @media screen and (min-width: 40em) {
          flex-flow: row nowrap;

        }
      }

      &-range {
        width: 100%;
        flex: 1 1 auto;
      }

      &-row {
        display: flex;
        flex-flow: row wrap;
        margin-right: -0.25em;
        margin-left: -0.25em;
      }
      &-col {
        width: 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding-right: 0.25em;
        padding-left: 0.25em;
        @media screen and (min-width: 40em) {
          flex: 0 0 50%;
          max-width: 50%;

        }
      }

      &-footer {
        display: flex;
        flex-flow: row nowrap;
        justify-content: stretch;
        align-content: flex-end;
        margin-top: 1em;
      }
    }
  }

</style>
